import { errorNotification, successNotification } from '../../shared/notification/store/actions';

import apiActionFactory from './apiActionFactory';

export const apiAction = apiActionFactory({ successNotification, errorNotification });
